export default "__VITE_ASSET__sR01sxNX__"